import { Box, Typography } from '@mui/material';

interface LayoutProps {
  mainHeading: string;
  subHeading: string;
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({
  mainHeading,
  subHeading,
  children
}) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding: '21px 20px',
      height: 'calc(100vh - 75px)',
      margin: '0px 22px 20px 22px',
      borderRadius: '12px',
      gap: '15px',
      backgroundColor: '#FFFFFF'
    }}
  >
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '11px',
        color: '#46464F',
        alignItems: 'flex-start'
      }}
    >
      <Typography sx={{ fontSize: '28px', fontWeight: '700' }}>
        {mainHeading}
      </Typography>
      <Typography sx={{ fontSize: '16px', fontWeight: '500' }}>
        {subHeading}
      </Typography>
    </Box>
    {children}
  </Box>
);

export default Layout;
